'use client';

import dynamic from 'next/dynamic';

// Loaded after hydration and outside the main bundle — most pages never show a hunt.
export const HuntOverlayLazy = dynamic(() => import('./HuntOverlay').then((m) => m.HuntOverlay), { ssr: false });
